module.exports = __webpack_public_path__ + "static/media/MWBStill.fdddb72a.jpg";